import { useNavigate } from 'react-router';
import { useAuth } from 'providers/AuthProvider';
import { weddingPaths } from 'routes/paths';
import { loginCouple } from 'services/api/auth';
import { getCoupleData } from 'services/api/couple';
import { adaptCoupleToUser } from 'services/api/adapters';
import LoginForm, { LoginFormValues } from 'components/sections/authentications/default/LoginForm';

const CoupleLogin = () => {
  const { setSession } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (data: LoginFormValues) => {
    const res = await loginCouple(data);

    if (res) {
      // Use adapter to convert wedding API response to Aurora User format
      const user = adaptCoupleToUser(res);

      // Set session with token first (needed for getCoupleData)
      setSession(user, res.token, res.refreshToken);

      // Fetch full event data to get plan and storage
      try {
        const coupleData = await getCoupleData();

        // Update session with complete user data including plan and storage
        setSession(
          {
            ...user,
            plan: coupleData.event.plan,
            storageUsed: coupleData.event.usedBytes,
            storageLimit: coupleData.event.maxBytes,
          },
          res.token,
          res.refreshToken,
        );
      } catch (error) {
        console.error('Failed to fetch event data:', error);
        // Session already set with basic user data if fetch fails
      }

      // Redirect to verify page if not verified, otherwise dashboard
      const isVerified = res.couple.isEmailVerified ?? false;
      navigate(isVerified ? weddingPaths.coupleDashboard : weddingPaths.coupleVerifyEmail);
    }
  };

  return (
    <LoginForm
      handleLogin={handleLogin}
      signUpLink={weddingPaths.coupleStart}
      forgotPasswordLink={weddingPaths.coupleForgotPassword}
      socialAuth={false}
      rememberDevice={false}
      enableTurnstile
    />
  );
};

export default CoupleLogin;
